// ============================================
// P1.5 G-05：组件面板交互工具（纯函数，便于单测）
// - 最近使用（localStorage，最多 8 个）
// - 键盘焦点移动（按网格列数计算上下）
// ============================================

const RECENT_KEY = 'dtwin-widget-recent';
const MAX_RECENT = 8;

export function readRecentTypes(): string[] {
  try {
    if (typeof localStorage === 'undefined') return [];
    const raw = localStorage.getItem(RECENT_KEY);
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr.filter((x) => typeof x === 'string') : [];
  } catch {
    return [];
  }
}

export function pushRecentType(type: string): void {
  try {
    if (typeof localStorage === 'undefined' || !type) return;
    const list = readRecentTypes().filter((t) => t !== type);
    list.unshift(type);
    localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, MAX_RECENT)));
  } catch {
    /* 忽略存储失败 */
  }
}

/** 按网格列数移动焦点（↑↓ 为 ±columns，←→ 为 ±1；循环钳制） */
export function moveFocus(index: number, delta: number, count: number): number {
  if (count <= 0) return 0;
  const next = index + delta;
  if (next < 0) return 0;
  if (next > count - 1) return count - 1;
  return next;
}

/** 由容器宽度计算网格列数（卡片宽 176 + 间距 12） */
export function computeColumns(containerWidth: number): number {
  const CARD = 176;
  const GAP = 12;
  if (!containerWidth || containerWidth <= CARD) return 1;
  return Math.max(1, Math.floor((containerWidth + GAP) / (CARD + GAP)));
}
